/* eslint-disable no-unused-vars */
import { getDatabase, ref, push, serverTimestamp } from "firebase/database";

import { CREATE_LEAD } from "../actions";

const database = getDatabase();

const state = {
  errors: null,
};

const getters = {};

const mutations = {};

const actions = {
  async [CREATE_LEAD](_, payload) {
    try {
      const createdAt = serverTimestamp();
      push(ref(database, `leads`), { createdAt, ...payload });

      return { isSuccess: true };
    } catch (error) {
      console.log(error);
      return { isSuccess: false, error };
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
